// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__OLVIK","heartbeat":"Loader_heartbeat__vAZmv"};